<template>
    <div class="generating-response-message">
        <avatar-icon v-if="isChatStyleFlat" smaller />

        <div class="generating-response-message__balloon">
            <loader-balls style="height: 1rem" />
        </div>
    </div>
</template>

<script setup lang="ts">
    import AvatarIcon from '@/components/avatar/AvatarIcon.vue';
    import LoaderBalls from '@/assets/loaderballs.svg?component';
    import useWidgetAppearance from '@/composables/useWidgetAppearance';

    const { isChatStyleFlat } = useWidgetAppearance();
</script>

<style scoped lang="scss">
    .generating-response-message {
        display: flex;
        align-items: flex-end;
        gap: .5rem;
        min-width: 100px;

        &__balloon {
            background-color: #F5F5F5;
            color: #c3c3c3;
            border-radius: .5rem .5rem .5rem 0;
            padding: 1rem;
            display: flex;
            align-items: center;
        }
    }

    @media (min-width: 768px) {
        .generating-response-message {
            &__balloon {
                max-width: 80%;
            }
        }
    }
</style>
